import { render } from "./KoruCurrencyField.vue?vue&type=template&id=69bb6f3d&ts=true"
import script from "./KoruCurrencyField.vue?vue&type=script&lang=ts"
export * from "./KoruCurrencyField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__